import React, { useCallback, useState } from "react";
import { Dialog, DialogContent, Box, Tabs, Tab, List, ListItem, } from "@mui/material";
import HeadingTree from "./HeadingTree";
import { translation } from "../Language";
function TabPanel({ children, value, index }) {
    return (React.createElement("div", { hidden: value !== index }, value === index && React.createElement(React.Fragment, null, children)));
}
const PageStructure = ({ isOpen = false, links = [], headings = [], onClose = () => { }, language = "en", bigCursor = false, }) => {
    const [value, setValue] = useState(0);
    const handleChange = useCallback((event, newValue) => {
        setValue(newValue);
    }, []);
    return (React.createElement(Dialog, { open: isOpen, onClose: onClose },
        React.createElement(DialogContent, { sx: { minWidth: "500px", minHeight: "60vh" }, className: bigCursor ? "cursor" : "" },
            React.createElement(Box, { sx: { width: "100%" } },
                React.createElement(Tabs, { value: value, onChange: handleChange, sx: { marginBottom: "10px" } },
                    React.createElement(Tab, { label: translation[language].links }),
                    React.createElement(Tab, { label: translation[language].headings })),
                React.createElement(TabPanel, { value: value, index: 0 },
                    React.createElement(List, null, links.map((l) => (React.createElement(ListItem, { key: l.href },
                        React.createElement("a", { href: l.href }, l.text ? l.text : l.href)))))),
                React.createElement(TabPanel, { value: value, index: 1 }, headings.map((heading, index) => (React.createElement(HeadingTree, { key: index, data: heading }))))))));
};
export default PageStructure;
//# sourceMappingURL=PageStructure.js.map